export const NPI_LABEL = 'NPI';
export const NPI_IDENTIFIER_TYPE = 'NPI';
export const newLabel = 'New Provider';

export const npiTemplate = {
  use: 'official',
  system: 'http://hl7.org/fhir/sid/us-npi',
  type: {
    coding: [
      {
        code: NPI_IDENTIFIER_TYPE,
        system: 'http://hl7.org/fhir/sid/us-npi',
        display: NPI_LABEL,
      },
    ],
  },
  value: '',
};
